import React, { useEffect } from 'react';
import { Form } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { useKindPackageGetAll, useMaterialCodeGetAll } from '../../../../../../hooks/api/order';
import OrderSelect, { OrderSelectProps } from '../Select';
import { FormNames, useOrderContextForm } from '../../context';

interface SelectMaterialCodeProps extends OrderSelectProps {
  prefix: FormNames
}

function SelectMaterialCode({
  fetch,
  selectProps = {},
  rest = {},
  ...props
}: SelectMaterialCodeProps) {
  const { forms: { [props.prefix]: form } } = useOrderContextForm();
  const index = (props.name as string[])[0];
  const materialCodeGet = useMaterialCodeGetAll();
  const kindPackageGet = useKindPackageGetAll();
  const packaging = Form.useWatch([props.prefix, index, 'packaging'], form);

  useEffect(() => {
    // eslint-disable-next-line no-nested-ternary
    const packageId = packaging
      ? (typeof packaging === 'object' ? packaging.value : packaging)
      : undefined;

    materialCodeGet.fetch({ packageId });
  }, [packaging]);

  return (
    <OrderSelect
      fetch={materialCodeGet}
      selectProps={{
        ...selectProps,
        onChange: (value, option) => {
          selectProps.onChange?.(value, option);

          if (!value || !option || Array.isArray(option)) {
            return;
          }

          const { packageId } = (option as DefaultOptionType & { packageId?: string | number });

          if (packageId === undefined || packageId === null) {
            return;
          }

          const kindOption = kindPackageGet.data?.find(
            ({ value: kindValue }) => String(kindValue) === String(packageId),
          );

          form.setFieldValue(
            [props.prefix, index, 'packaging'],
            kindOption || { value: packageId, label: String(packageId) },
          );
        },
      }}
      rest={rest}
      {...props}
    />
  );
}

export default SelectMaterialCode;
